<template>
<!-- Modal -->
  <div
    id="noUpgradeAvailableModal"
    class="modal fade show"
    tabindex="-1"
    aria-labelledby="noUpgradeAvailableLabel"
    aria-hidden="true"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content border-0">
        <div class="modal-header text-center border-bottom-0">
          <h5
            class="modal-title flex-grow-1 font-weight-bold"
            id="noUpgradeAvailableLabel"
            v-html="title"
          ></h5>
          <button
            type="button"
            class="close"
            aria-label="Close"
            v-on:click="closeModal"
          >
            <i
              v-if="isFullscreen"
              class="mp mp-close"
              aria-label="Close"></i>
            <span v-if="!isFullscreen" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p v-html="body"></p>

          <a
            v-if="electricalContractorLink"
            class="btn btn-primary btn-block"
            v-bind:href="electricalContractorLink"
            target="_blank"
            v-html="buttonLinkText"
          ></a>
          <button
            type="button"
            class="btn btn-secondary btn-block"
            v-if="!isFullscreen"
            v-on:click="closeModal"
          >Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { mapGetters, mapState } from 'vuex';
import SegmentMixin from '@/mixins/SegmentMixin';

export default {
  name: 'NoPanelUpgradeModal',
  mixins: [
    SegmentMixin,
  ],
  data() {
    return {
      defaultTitle: 'Electrical Panel Upgrade',
      defaultBody: `An electrical panel upgrade is not available at this time and would be
                    required to be done separately in order for the water heater to be installed.<br><br>
                    You may continue with the purchase, but you will need to find an electrician
                    to do the panel upgrade work. Upgrades typically run around $4000`,
      defaultButtonLinkText: 'Find a Contractor Near You',
    };
  },
  computed: {
    ...mapGetters('cmsText', [
      'getCMSText',
    ]),
    ...mapState('siteSettings', ['settings']),

    title() {
      return this.getCMSText('electrical_panel_upgrade:upgrade_not_available:title', {}, this.defaultTitle);
    },

    body() {
      return this.getCMSText('electrical_panel_upgrade:upgrade_not_available:body', {}, this.defaultBody);
    },

    buttonLinkText() {
      return this.getCMSText('electrical_panel_upgrade:upgrade_not_available:button_link_text', {}, this.defaultButtonLinkText);
    },

    electricalContractorLink() {
      return this.settings?.rebateConfig?.waterHeaterElectricalContractorLink;
    },

    isFullscreen() {
      return (/true/).test(this.$route?.query.fullScreen);
    },
  },
  methods: {
    closeModal() {
      $('#noUpgradeAvailableModal').removeClass('show');
      $('#noUpgradeAvailableModal').attr('style', 'display: none');
      this.trackEvent('Electrical-panel-required-modal-engaged');
    },
  },
};
</script>
